import {IErrorResponseItem, ValidationError, ValidationErrors} from "../services/validator";
import { TransactionValidationField } from "./transactions";
import { ISubTransaction } from "../components/Transactions/Components/Form/Fields/Details/Fields/SubTransactions/SubTransactionsField";

export type SubTransactionValidation = {
    [key in TransactionValidationField]?: ValidationError[];
};

export type SubTransactionValidationErrors = ValidationErrors<SubTransactionValidation, TransactionValidationField>;

export const subTransactionValidationFactory = (errors: IErrorResponseItem[]): SubTransactionValidationErrors => {
    const v = new ValidationErrors<SubTransactionValidation, TransactionValidationField>();
    v.setMap({
        date: TransactionValidationField.SUB_TRANSACTION_DATE,
        amount: TransactionValidationField.SUB_TRANSACTION_AMOUNT,
        description: TransactionValidationField.SUB_TRANSACTION_DESCRIPTION,
    });
    v.setErrors(errors);

    return v;
};

export const validateSubTransactionForm = (data: ISubTransaction): SubTransactionValidationErrors => {
    const errors = subTransactionValidationFactory([]);

    if (!data.date.isValid()) {
        errors.add(TransactionValidationField.SUB_TRANSACTION_DATE, ValidationError.REQUIRED);
    }
    if (!data.amount || isNaN(data.amount)) {
        errors.add(TransactionValidationField.SUB_TRANSACTION_AMOUNT, ValidationError.REQUIRED);
    }
    if (data.description === '') {
        errors.add(TransactionValidationField.SUB_TRANSACTION_DESCRIPTION, ValidationError.REQUIRED);
    }

    return errors;
};
